var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataSource(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3,7c2,0,3.6,1.6,3.6,3.6c0,0.9-0.3,1.7-0.9,2.4l2.5,2.4L15,15.8l-2.5-2.4c-0.6,0.5-1.4,0.8-2.2,0.8 c-2,0-3.6-1.6-3.6-3.6S8.3,7,10.3,7z M10.3,7.7c-1.6,0-2.9,1.3-2.9,2.9s1.3,2.9,2.9,2.9s2.9-1.3,2.9-2.9S11.8,7.7,10.3,7.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2,0.2v10.4l0-0.2c-0.1-2.1-1.8-3.8-4-3.8c-0.4,0-0.7,0.1-1.1,0.1l0-4.6l-3.6-1v10l0.8,0.2 c0.1,0.3,0.1,0.6,0.3,0.8l-1.8-0.5l-4.3,1.4V1.6l4.3-1.4l5,1.4L14.2,0.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2,10.6v1.1L14,11.7c0.1-0.3,0.1-0.6,0.2-0.9L14.2,10.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataSource);
export default __webpack_public_path__ + "static/media/data_source.09049c6e7a60de2ff6da78d6c5cb8d01.svg";
export { ForwardRef as ReactComponent };